import React from 'react';

const formatPrice = (p) => `${p?.toLocaleString() || 0}`;

// Thermal print CSS optimized for 80mm (APR-E802, ESC/POS compatible printers)
const THERMAL_STYLES = `
  @page { size: 80mm auto; margin: 0; padding: 0; }
  @media print {
    html, body { width: 80mm; margin: 0; padding: 0; }
    body { -webkit-print-color-adjust: exact; print-color-adjust: exact; }
  }
  body {
    font-family: 'Courier New', 'Lucida Console', monospace;
    font-size: 12px;
    width: 72mm;
    max-width: 72mm;
    margin: 0 auto;
    padding: 3mm 2mm;
    line-height: 1.3;
    color: #000;
  }
  .center { text-align: center; }
  .bold { font-weight: bold; }
  .big { font-size: 16px; font-weight: bold; }
  .line { border-top: 1px dashed #000; margin: 4px 0; }
  .dline { border-top: 2px solid #000; margin: 6px 0; }
  table { width: 100%; border-collapse: collapse; }
  td { padding: 1px 0; vertical-align: top; font-size: 12px; }
  .notes { font-style: italic; font-size: 11px; margin-top: 4px; padding: 3px; border: 1px dashed #666; }
  .logo { font-size: 20px; font-weight: bold; letter-spacing: 2px; }
  .small { font-size: 10px; }
`;

export const printKitchenTicket = (order) => {
  const w = window.open('', '_blank', 'width=350,height=600');
  if (!w) return;
  const items = (order.items || []).map(i =>
    `<tr><td style="text-align:left;font-size:14px;font-weight:bold">${i.quantity}x ${i.name}</td><td style="text-align:right">${formatPrice(i.price * i.quantity)}</td></tr>`
  ).join('');
  w.document.write(`<!DOCTYPE html><html><head><style>${THERMAL_STYLES}
    td { font-size: 13px; }
  </style></head><body>
    <div class="center bold big">BON DE COMMANDE</div>
    <div class="center small">${new Date().toLocaleString('fr-FR')}</div>
    <div class="dline"></div>
    <div class="bold" style="font-size:16px">${order.is_takeaway ? (order.order_source === 'click_collect' ? 'CLICK & COLLECT' : 'A EMPORTER') : 'TABLE ' + (order.table_id || '?')}</div>
    ${order.order_number ? `<div class="small">Commande #${order.order_number}</div>` : ''}
    ${order.server_name ? `<div class="small">Serveur: ${order.server_name}</div>` : ''}
    ${order.order_source && !['dine_in','takeaway','click_collect'].includes(order.order_source) ? `<div class="bold" style="margin-top:2px;font-size:14px">${order.order_source.toUpperCase()}</div>` : ''}
    <div class="dline"></div>
    <table>${items}</table>
    <div class="dline"></div>
    <table><tr><td class="bold">TOTAL</td><td style="text-align:right" class="bold big">${formatPrice(order.total || order.items?.reduce((s,i) => s + i.price * i.quantity, 0) || 0)}</td></tr></table>
    ${order.notes ? `<div class="notes">NOTE: ${order.notes}</div>` : ''}
    <div class="line"></div>
    <div class="center small" style="margin-top:4px">--- FIN ---</div>
    <div id="pf" style="text-align:center;padding:10px;position:fixed;bottom:0;left:0;right:0;background:#fff;border-top:1px solid #ccc;z-index:999"><button onclick="window.print()" style="padding:12px 40px;font-size:16px;font-weight:bold;background:#0A422D;color:#fff;border:none;border-radius:8px;cursor:pointer">IMPRIMER</button></div><script>setTimeout(function(){try{window.print()}catch(e){}},600)<\/script>
  </body></html>`);
  w.document.close();
};

export const printClientReceipt = (order, restaurantName = 'HIBISUN') => {
  const w = window.open('', '_blank', 'width=350,height=700');
  if (!w) return;
  const items = (order.items || []).map(i =>
    `<tr><td style="text-align:left">${i.quantity}x ${i.name}</td><td style="text-align:right">${formatPrice(i.price * i.quantity)}</td></tr>`
  ).join('');
  const total = order.total || 0;
  const discount = order.discount_amount || 0;
  const paid = order.paid_amount || total;
  const paymentMethod = order.payment_method || '';
  const methodLabel = { cash: 'Especes', card_terminal: 'Carte bancaire', promptpay: 'PromptPay', counter: 'Comptoir' };
  w.document.write(`<!DOCTYPE html><html><head><style>${THERMAL_STYLES}</style></head><body>
    <div class="center logo">${restaurantName}</div>
    <div class="center small">${new Date().toLocaleString('fr-FR')}</div>
    ${order.order_number ? `<div class="center small">Ticket #${order.order_number}</div>` : ''}
    <div class="line"></div>
    <div class="small" style="margin-bottom:4px">${order.is_takeaway ? (order.order_source === 'click_collect' ? 'Click & Collect' : 'A emporter') : 'Table ' + (order.table_id || '')}</div>
    <table>${items}</table>
    <div class="line"></div>
    ${discount > 0 ? `<table><tr><td>Sous-total</td><td style="text-align:right">${formatPrice(total)}</td></tr><tr><td>Remise</td><td style="text-align:right">-${formatPrice(discount)}</td></tr></table><div class="line"></div>` : ''}
    <table><tr><td class="bold">TOTAL</td><td style="text-align:right" class="big">${formatPrice(total - discount)}</td></tr></table>
    ${paymentMethod ? `<div class="small" style="margin-top:4px">Paye par: ${methodLabel[paymentMethod] || paymentMethod}</div>` : ''}
    ${paid > (total - discount) ? `<div class="small">Rendu: ${formatPrice(paid - (total - discount))}</div>` : ''}
    <div class="line"></div>
    <div class="center small" style="margin-top:4px">Merci de votre visite !</div>
    <div class="center" style="font-size:9px">TVA incluse</div>
    <div id="pf" style="text-align:center;padding:10px;position:fixed;bottom:0;left:0;right:0;background:#fff;border-top:1px solid #ccc;z-index:999"><button onclick="window.print()" style="padding:12px 40px;font-size:16px;font-weight:bold;background:#0A422D;color:#fff;border:none;border-radius:8px;cursor:pointer">IMPRIMER</button></div><script>setTimeout(function(){try{window.print()}catch(e){}},600)<\/script>
  </body></html>`);
  w.document.close();
};

export const PrintTicketButton = ({ order, type = 'kitchen', restaurantName, className = '', children }) => {
  const handlePrint = (e) => {
    e.stopPropagation();
    if (type === 'receipt') {
      printClientReceipt(order, restaurantName);
    } else {
      printKitchenTicket(order);
    }
  };
  return (
    <button onClick={handlePrint} className={className} data-testid={`print-${type}-${order.id || 'new'}`}>
      {children}
    </button>
  );
};
